import React from 'react'
import { Card } from '@myxplor/ui'

import LocalAsyncStore from '../local-async-store'
import ParentAgreementView from './views'

export const Container = props => (
  <Card title="Parent Agreement" embedded={props.embedded} className="parentAgreement--wrapper">
    <ParentAgreementView
      care_id={props.care_id}
      parent_id={props.parent_id}
      {...props.parent_agreement}
      refresh_parent_agreement={props.refresh_parent_agreement}
    />
  </Card>
)

export const apiEndPoint = ({ parent_id, care_id }) =>
  `/api/parents/${parent_id}/care-enrolments/${care_id}/parent-approvals/latest`

export default LocalAsyncStore('parent_agreement', Container, apiEndPoint)



// WEBPACK FOOTER //
// ./src/parent-agreement/index.js